import React from 'react';

export default () => <div className="NotFoundPage">
    not found
</div>
